import styles from './Spinner.module.css';

/** 진행 표시. 화면 전체를 덮지 않고 그 자리에만 둔다. */
export function Spinner({ size = 20, label }: { size?: number; label?: string }) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label ?? 'loading'}
    />
  );
}
